import React from 'react'
import MarkdownIt from 'markdown-it'
const md = new MarkdownIt()

import Footer from '../components/footer'
import Header from '../components/header'
import Nav from '../components/nav'

class NotFoundPage extends React.Component {
  render () {
    const page = this.props.data.contentfulPage
    const headerTitle = md.renderInline(page.headerTitle.headerTitle)
    const footer = {
      footerCatchphrase: page.footerCatchphrase.footerCatchphrase,
      footerNav: page.footerNav
    }
    console.log()
    return (
      <div>
        <Nav data={page.navigationBar} />
        <Header
          navItems={page.navigationBar}
          template='secondary'
          bgImage={page.headerBackground.file.url}
          headingText={headerTitle}
          subheadingText={page.headerSubtitle}
        />
        <div className='u-marginVerticalLarge'>
          <div className='container'>
            <p>Please use the navigation, or click <a href='/' style={{color: '#3138CF'}}>here</a> to return to the homepage</p>
          </div>
        </div>
        <Footer data={footer} secondary />
      </div>
    )
  }
}

export const pageQuery = graphql`
  query notFound {
    contentfulPage(pageName: {eq: "404"}) {
      id
      navigationBar {
        id
        navigationItems {
          id
          pageName
        }
      }
      headerTitle {
        headerTitle
      }
      headerBackground {
        id
        file {
          url
          fileName
          contentType
        }
      }
      headerSubtitle
      footerCatchphrase {
        id
        footerCatchphrase
      }
      footerNav {
        id
        footerCopyrights
        footerAddress
      }
    }
  }
`

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/pages/error.js